<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="add"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :pageParams="queryParams"
      :total="total"
      @pageChange="handleSearch"
    >
      <!-- <template slot="details" slot-scope="scope">
        <div>
          <span>{{scope.data.cnProvinceName}}</span>
          <span>{{scope.data.cnCityName}}</span>
          <span>{{scope.data.cnDistrictName}}</span>
          <span>{{scope.data.details}}</span>
        </div>
      </template> -->
      <template slot="createTime" slot-scope="scope">
        <span>{{parseTime(scope.data.createTime, '{y}-{m}-{d}') }}</span>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':edit']"
          class="button"
          type="text"
          size="small"
          @click="handleUpdata(scope.data, scope.$index)"
        >修改</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          @click="handleSee(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
        >详情</el-button>
        <el-button
          :disabled="scope.data.vehNum"
          v-hasPermi="[authIdentity + ':del']"
          class="delbutton"
          type="text"
          size="small"
          @click="handleDel(scope.data, scope.$index)"
        >删除</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':carDetail']"
          @click="handleCarDetail(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
        >车辆明细</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView"></component>
      <span slot="footer" v-if=" type != 'preview'">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/library/logistics/components/form'
import { getSupplierList, getSupplierDetail, logicDelete } from '@/api/library/logistics'
export default {
  name: 'Logistics',
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
  },
  data() {
    const _this = this
    return {
      type: '',
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      authIdentity: 'library:logistics',
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'name',
          label: '供应商名称',
          isTrue: true,
          align: 'left'
        },
        {
          prop: 'contactName',

          label: '联系人',
          isTrue: true,
        },
        {
          prop: 'contactInfo',
          label: '联系方式',
          isTrue: true,
        },
        {
          prop: 'details',
          label: '供应商地址',
          isTrue: true,
          align: 'left',
          formatter(row) {
            let addressArr = [row.cnProvinceName, row.cnCityName, row.cnDistrictName, row.details]
            let address = _this.uniqueArr2(addressArr).join('').replace(/undefined|null/g, '')
            return address
          },
        },
        {
          prop: 'vehNum',
          label: '车辆数量',
          isTrue: true,
        },
        {
          prop: 'createTime',
          label: '创建时间',
          isTrue: true,
          formSolt: true,
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'name',
          placeholder: '请输入供应商名称',
          class: 'home',
          type: 'input',
        },
      ],
    }
  },
  created() {
    this.getSupplierList()
  },
  methods: {
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          logicDelete({ id: row.id }).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`操作成功！`)
              this.getSupplierList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
      }
      this.getSupplierList()
    },
    handleSearch(data) {
      console.log(data, '----------------------')
      if (data) {
        for (let key in data) {
          this.queryParams[key] = data[key]
        }
      }

      this.getSupplierList()
    },
    getSupplierList() {
      getSupplierList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items
            this.total = res.data.totalCount
            console.log(this.tableData, 'this.tableDatathis.tableData--------------')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleCarDetail(row) {
      this.$router.push({ path: '/carDetail', query: { id: row.id } })
      // this.$router.push('/carDetail')
    },
    submitFrom() {
      console.log('进来')
      this.$refs.myform.submit(this.type, (data) => {
        console.log(data)

        if (data) {
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.getSupplierList()
        }
      })
    },
    cancel() {
      this.$refs.myform.reset()
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '新增供应商'

        this.type = 'add'
        console.log(this.type, 'this.type---------')
        this.$refs.myform.add(this.type)
      })
    },
    handleSee(row) {
      getSupplierDetail({ id: row.id })
        .then((res) => {
          if (res.flag) {
            let data = {
              name: '',
              contactName: '',
              parentFullCodeList: [],
              contactInfo: '',
              details: '',
              provinceCode: '',
              cityCode: '',
              districtCode: '',
              id: '',
              cnProvinceName: '',
              cnCityName: '',
              cnDistrictName: '',
              remark: '',
            }
            for (let key in data) {
              if (key !== 'parentFullCodeList') {
                data[key] = res.data[key]
              }
            }

            data.parentFullCodeList.push(data.provinceCode)
            data.parentFullCodeList.push(data.cityCode)
            data.parentFullCodeList.push(data.districtCode)

            this.dialogVisible = true
            this.currentView = 'myform'
            this.$nextTick(() => {
              this.title = '查看供应商'
              this.type = 'preview'
              this.$refs.myform.getDetail(data, this.type)
            })
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleUpdata(row) {
      getSupplierDetail({ id: row.id })
        .then((res) => {
          if (res.flag) {
            let data = {
              name: '',
              contactName: '',
              parentFullCodeList: [],
              contactInfo: '',
              details: '',
              provinceCode: '',
              cityCode: '',
              districtCode: '',
              id: '',
              cnProvinceName: '',
              cnCityName: '',
              cnDistrictName: '',
              remark: '',
            }
            for (let key in data) {
              if (key !== 'parentFullCodeList') {
                data[key] = res.data[key]
              }
            }

            data.parentFullCodeList.push(data.provinceCode)
            data.parentFullCodeList.push(data.cityCode)
            data.parentFullCodeList.push(data.districtCode)

            this.dialogVisible = true
            this.currentView = 'myform'
            this.$nextTick(() => {
              this.title = '修改供应商'
              this.type = 'edit'
              this.$refs.myform.getDetail(data, this.type)
            })
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
<style scoped lang='less'>
@import '~@/assets/tableList.less';
/deep/ .delbutton.el-button--text {
  color: red;
}
/deep/ .el-button--text {
  font-size: 14px;
}
// @import '../../../../assets/form.less';
</style>